import React from "react";
import { MenuItem } from "@mui/material";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";

function BackgroundRepeat({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={""}>
          Default
        </MenuItem>,
        ["repeat-x", "repeat-y", "repeat", "space", "round", "no-repeat"].map((repeat) => {
          return (
            <MenuItem key={repeat} value={repeat}>
              {repeat}
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSBackgroundRepeatComponent: JSInputComponent = {
  Component: BackgroundRepeat,
  handlesCssProperties: ["backgroundRepeat"],
};
